module.exports = __webpack_public_path__ + "static/media/double-right-blue.7779299a.svg";